import { useState } from "react";
import { Alert, Box, Typography, Stack, MenuItem, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";

// This draft belongs to the dialog so editing never redraws the pipeline.
function AgendarForm({ open, onClose, lead, initialDays, onConfirm, unavailable }) {
  const [form, setForm] = useState({ modo: "dias", dias: initialDays || 1, fecha: "", tipo: "seguimiento" });
  const submit = e => {
    e.preventDefault();
    if (unavailable) return;
    if (form.modo === "fecha" && !form.fecha) return;
    const data = new FormData(e.currentTarget);
    onConfirm({ ...form, descripcion: String(data.get("descripcion") || "") });
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle fontWeight={700} sx={{ pb: 1 }}>Agendar acción</DialogTitle>
        <form onSubmit={submit}>
        <DialogContent>
          {unavailable && <Alert severity="warning">Este cliente ya no está disponible. Puedes copiar tu descripción antes de cerrar.</Alert>}
          <Stack spacing={2} mt={1}>
            <TextField
              select
              label="Tipo de acción"
              size="small"
              value={form.tipo}
              onChange={e => setForm(p => ({ ...p, tipo: e.target.value }))}
              fullWidth
            >
              <MenuItem value="seguimiento">Seguimiento</MenuItem>
              <MenuItem value="visita">Visita</MenuItem>
              <MenuItem value="llamada">Llamada</MenuItem>
            </TextField>

            <Box>
              <Typography variant="caption" color="text.secondary" mb={0.5} display="block">Programar por</Typography>
              <ToggleButtonGroup
                value={form.modo}
                exclusive
                onChange={(_, v) => v && setForm(p => ({ ...p, modo: v }))}
                size="small"
                fullWidth
              >
                <ToggleButton value="dias">Días</ToggleButton>
                <ToggleButton value="fecha">Fecha</ToggleButton>
              </ToggleButtonGroup>
            </Box>

            {form.modo === "dias" ? (
              <TextField
                label="En cuántos días"
                type="number"
                size="small"
                inputProps={{ min: 1 }}
                value={form.dias}
                onChange={e => setForm(p => ({ ...p, dias: Math.max(1, +e.target.value) }))}
                fullWidth
              />
            ) : (
              <TextField
                label="Fecha"
                type="date"
                size="small"
                InputLabelProps={{ shrink: true }}
                value={form.fecha}
                onChange={e => setForm(p => ({ ...p, fecha: e.target.value }))}
                fullWidth
              />
            )}

            <TextField
              label="Descripción"
              size="small"
              multiline
              minRows={2}
              name="descripcion"
              defaultValue={"Seguimiento a " + lead.nombre}

              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            variant="contained"
            type="submit"
            disabled={unavailable || (form.modo === "fecha" && !form.fecha)}
          >
            Agendar
          </Button>
        </DialogActions>
        </form>
      </Dialog>
  );
}
export default function AgendarAccionDialog(props) {
  return props.open && props.lead ? <AgendarForm key={props.lead.id} {...props} /> : null;
}
